import { DatadogTrack } from '@cobliteam/datadog-rum';
import useWaitingForGoogleMaps from '@cobliteam/hooks/src/useWaitingForGoogleMaps';
import { memo, useEffect } from 'react';
import { useMap as useMapLeaflet } from 'react-leaflet';

const StreetView = () => {
  const map = useMapLeaflet();
  const isGoogleMapsLoaded = useWaitingForGoogleMaps();

  useEffect(() => {
    let pegmanControl: any = null;

    const initializePegman = () => {
      try {
        if (!isGoogleMapsLoaded) return;
        if (!window.google?.maps?.StreetViewPanorama) return;
        // @ts-ignore
        if (!(globalThis as any).L?.Control?.Pegman) return;

        // @ts-ignore
        pegmanControl = new (globalThis as any).L.Control.Pegman({
          position: 'bottomleft',
          theme: 'leaflet-pegman-v3-small',
        });

        pegmanControl.addTo(map);
      } catch (err) {
        console.error('Failed to initialize Street View:', err);
        DatadogTrack.action('Failed to initialize Street View', {
          error: err,
        });
      }
    };

    initializePegman();

    return () => {
      try {
        if (pegmanControl) {
          pegmanControl.remove();
          pegmanControl = null;
        }
      } catch (err) {
        // ignore cleanup errors
      }
    };
  }, [map, isGoogleMapsLoaded]);

  return null;
};

export default memo(StreetView);